// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — unrecognized.styled.classic.js, новая — unrecognized.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './unrecognized.styled.classic';
import * as cp from './unrecognized.styled.cp';

export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Calls = isCp ? cp.Calls : classic.Calls;
export const Content = isCp ? cp.Content : classic.Content;
export const Inner = isCp ? cp.Inner : classic.Inner;
export const ItemContainer = isCp ? cp.ItemContainer : classic.ItemContainer;
export const PlateInfo = isCp ? cp.PlateInfo : classic.PlateInfo;
export const SectionLabel = isCp ? cp.SectionLabel : undefined;
export const Title = isCp ? cp.Title : classic.Title;
export const VehicleClass = isCp ? cp.VehicleClass : classic.VehicleClass;
export const VehicleClassInfo = isCp ? cp.VehicleClassInfo : classic.VehicleClassInfo;
